/**
 * Stage-1 review finding 5: the "Load more" control both saved-routines surfaces share. Atlas
 * pages the list (25 by default); without this a person's 26th routine could not be reached.
 * A native button, so Tab, Enter and Space work with no script of ours. A failed next page keeps
 * what is shown, says so, and the same button tries again.
 */
import type { UsePersonalRoutinesResult } from "../../hooks/usePersonalRoutines";

export function PersonalRoutinesMore({
  list,
  compact = false,
}: {
  list: Pick<UsePersonalRoutinesResult, "hasMore" | "loadMore" | "loadingMore" | "loadMoreFailed">;
  compact?: boolean;
}) {
  if (!list.hasMore) {
    return null;
  }
  return (
    <div className={compact ? "mt-1 px-2" : "mt-2"}>
      {list.loadMoreFailed && (
        <p role="status" className="text-xs text-muted-foreground">
          More routines couldn't be loaded.
        </p>
      )}
      <button
        type="button"
        aria-label="Load more routines"
        disabled={list.loadingMore}
        onClick={() => void list.loadMore()}
        className={
          compact
            ? "rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-muted focus:outline-none focus-visible:ring-2"
            : "rounded-md border px-2 py-1 text-xs focus:outline-none focus-visible:ring-2"
        }
      >
        {list.loadingMore ? "Loading…" : "Load more"}
      </button>
    </div>
  );
}
